import * as PropTypes from 'prop-types';
import React from 'react';
import useViewport from '../hooks/use.viewport';
import the from '../objects/the';
import Button from './button';
import TranslatedSpan from './translated.span';

const MedicareNumberLabel = props => {
    const {width} = useViewport();
   
    return <>
        <div>
            <TranslatedSpan english={'Medicare Number'}/>
        </div>
        <Button
            analyticsDescription={'open Medicare Number dialog'}
            color={'blue'}
            displayAs={'link'}
            onClick={props.onClick}
            style={{
                padding: 0,
                textAlign: 'left',
            }}
        >
            <TranslatedSpan
                english={'Where can I find my Medicare Number?'}
                style={{
                    fontFamily: 'Rubik',
                    fontSize: width < the.minimumMediumViewportWidth ? 14 : 16,
                    fontWeight: 400,
                    lineHeight: width < the.minimumMediumViewportWidth ? 1 : 1.3,
                    textTransform: 'none',
                }}
            />
        </Button>
    </>;
}

MedicareNumberLabel.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default MedicareNumberLabel;